import filterWhitespaceNodes from "./filterWhitespaceNodes";
import walk from "./walk";
export default filterWhitespaceNodes;
export { walk };